import React from 'react';

const StrengthItem = ({ icon, title }) => {
  return (
    <article className="strength-item group w-full min-h-[170px] md:min-h-[190px] text-center p-4 md:p-8 rounded-2xl transition-all duration-[800ms] cursor-default bg-primary-green-dark/30 border border-primary-green-light/30 shadow-card flex flex-col items-center justify-center">
      <div className="inline-flex items-center justify-center w-16 h-16 md:w-20 md:h-20 rounded-2xl bg-gradient-to-br from-accent-gold/20 to-primary-green-light/20 mb-3 md:mb-5 transition-transform duration-500 group-hover:scale-110">
        <i className={`fas ${icon} text-3xl md:text-4xl text-accent-gold`} aria-hidden="true"></i>
      </div>
      <h3 className="text-xs md:text-base font-semibold text-white leading-tight max-w-full">{title}</h3>
    </article>
  );
};

const Strengths = () => {
  const strengths = [
    { icon: 'fa-ruler-combined', title: 'High Precision Machining' },
    { icon: 'fa-users', title: 'Experienced Team' },
    { icon: 'fa-microchip', title: 'Advanced CNC VMC Machines' },
    { icon: 'fa-clock', title: 'On-time Delivery' },
    { icon: 'fa-handshake', title: 'Manufacturing Support' },
    { icon: 'fa-check-circle', title: 'Quality Assurance' },
    { icon: 'fa-heart', title: 'Customer Satisfaction' },
  ];

  return (
    <section id="strengths" className="strengths py-12 md:py-24 px-[5%] bg-primary-dark" aria-labelledby="strengths-heading">
      <h2 id="strengths-heading" className="section-title text-center text-3xl md:text-4xl lg:text-5xl font-bold mb-8 md:mb-12 bg-gradient-to-r from-white via-primary-green-light to-accent-gold bg-clip-text text-transparent" aria-label="Jay Ambe Engineering strengths as a precision machining company in Vadodara">
        Core Strengths
      </h2>
      <p className="sr-only">
        Jay Ambe Engineering aims to be the best company in GIDC and best company Vadodara for precision machining, CNC work, VMC work and customer-focused manufacturing support.
      </p>

      <div className="strengths-grid grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-8 max-w-[1400px] mx-auto mt-8 md:mt-16">
        {strengths.map((strength) => (
          <StrengthItem key={strength.title} icon={strength.icon} title={strength.title} />
        ))}
      </div>
    </section>
  );
};

export default Strengths;
